const { RichText, InnerBlocks } = wp.blockEditor;

export default ({ attributes }) => {
  const {
    text,
    containerized,
    align,
    color,
    margin,
    removeMarker,
    maxWidth,
    fontWeight,
  } = attributes;

  return (
    <div
      className={`only-text paragraph-block ${color} ${
        removeMarker ? 'removeMarker' : ''
      } ${maxWidth}`}
    >
      <div
        className={`only-text__content ${
          containerized ? 'Container' : ''
        } ${margin}`}
      >
        {text && (
          <RichText.Content
            tagName="p"
            className={`Typography text ${align}  ${fontWeight}`}
            value={text}
          />
        )}

        <InnerBlocks.Content />
      </div>
    </div>
  );
};
